import { eCDV3ItemTypes } from '../../../ui-toolkit/enums/eCDV3ItemTypes';
import { ICDV3ViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';
import { TitleFeesThatGoInSectionH } from '../../../ui-toolkit/enums/TitleFeesThatGoInSectionH';

export const updateMoveAttributesBasedOnType = (item: ICDV3ViewItem) =>
  (item.type === eCDV3ItemTypes.title_fee && (!item.sub_type || !TitleFeesThatGoInSectionH.includes(item.sub_type))) ||
  item.type === eCDV3ItemTypes.title_fee_other ||
  item.type === eCDV3ItemTypes.endorsement ||
  item.type === eCDV3ItemTypes.endorsement_other ||
  item.type === eCDV3ItemTypes.other_loan_cost ||
  item.type === eCDV3ItemTypes.sales_tax ||
  item.type === eCDV3ItemTypes.appraisal_fee
    ? { ...item, shopped_for: !item.shopped_for, dirty: true }
    : undefined;
